module.exports = __webpack_public_path__ + "img/equipment-cap-02.7b743948.png";